export default __webpack_public_path__ + "static/media/Cargo6.11446327.png";